import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { PageHero } from '../components/PageHero';
import { Cookie } from 'lucide-react';

const CookieRichtliniePage = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />
      <main className="flex-1">
        
        {/* Einheitlicher Hero mit PageHero Komponente */}
        <PageHero
          title="Cookie-Richtlinien"
          subtitle="Informationen zur Verwendung von Cookies auf unserer Website"
          badges={[
            { icon: Cookie, text: 'Cookie-Hinweise', bgColor: 'bg-amber-600 text-white' },
            { text: 'Transparente Nutzung', variant: 'white' }
          ]}
          backgroundImage="https://customer-assets.emergentagent.com/job_erste-hilfe-portal/artifacts/esmxh13l_130A96D7-40D9-4B5C-B8BF-2736FD362E96.png"
          backgroundPosition="center 40%"
          variant="simple"
        />

        {/* INHALT - Same container width as navbar */}
        <section className="py-12 sm:py-16">
          <div className="max-w-[1664px] mx-auto px-4 sm:px-6 lg:px-8">
            <div className="prose prose-lg max-w-none text-slate-600 space-y-6">
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Anbieter / Diensteanbieter</h2>
              <p>
                Erste Hilfe Germany GbR<br />
                Poststraße 6<br />
                46236 Bottrop<br />
                Deutschland
              </p>
              <p>
                <strong>Vertretungsberechtigte Gesellschafter:</strong><br />
                Herr Yasar Kartal<br />
                Herr Jan Hassel
              </p>
              <p>
                Die Gesellschaft wird durch die Gesellschafter gemeinschaftlich vertreten.<br />
                Beide Gesellschafter haften im Rahmen der gesetzlichen Vorschriften.
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Was sind Cookies?</h2>
              <p>
                Cookies sind kleine Textdateien, die auf Ihrem Computer oder mobilen Gerät gespeichert 
                werden, wenn Sie eine Website besuchen. Sie werden häufig verwendet, um Websites 
                effizienter zu gestalten und Informationen an die Eigentümer der Website zu übermitteln.
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Wie verwenden wir Cookies?</h2>
              <p>
                Wir verwenden Cookies aus verschiedenen Gründen, die im Folgenden erläutert werden. 
                Leider gibt es in den meisten Fällen keine branchenüblichen Optionen, um Cookies zu 
                deaktivieren, ohne die Funktionalität und Merkmale, die sie dieser Website hinzufügen, 
                vollständig zu deaktivieren.
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Arten von Cookies</h2>
              
              <h3 className="text-xl font-semibold text-[#1e3a5f] mt-6 mb-3">Notwendige Cookies</h3>
              <p>
                Diese Cookies sind für das Funktionieren der Website unbedingt erforderlich. 
                Sie ermöglichen grundlegende Funktionen wie Seitennavigation und Zugriff auf 
                sichere Bereiche der Website.
              </p>
              
              <h3 className="text-xl font-semibold text-[#1e3a5f] mt-6 mb-3">Funktionale Cookies</h3>
              <p>
                Diese Cookies ermöglichen es der Website, erweiterte Funktionalität und 
                Personalisierung bereitzustellen. Sie können von uns oder von Drittanbietern 
                gesetzt werden, deren Dienste wir auf unseren Seiten nutzen.
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Cookies deaktivieren</h2>
              <p>
                Sie können das Setzen von Cookies verhindern, indem Sie die Einstellungen in 
                Ihrem Browser anpassen. Beachten Sie jedoch, dass das Deaktivieren von Cookies 
                die Funktionalität dieser und vieler anderer Websites, die Sie besuchen, 
                beeinträchtigen kann.
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Weitere Informationen</h2>
              <p>
                Wenn Sie sich nicht sicher sind, ob Sie Cookies benötigen oder nicht, ist es in 
                der Regel sicherer, Cookies aktiviert zu lassen, falls sie mit einer der von Ihnen 
                genutzten Funktionen interagieren.
              </p>
              <p>
                Bei Fragen zu unserer Cookie-Richtlinie können Sie uns gerne kontaktieren:<br />
                E-Mail: info@erstehilfebottrop.de
              </p>
            </div>
          </div>
        </section>

      </main>
      <Footer />
    </div>
  );
};

export default CookieRichtliniePage;
